export const MAXIMUM_TITLE_LENGTH = 260;
export const TITLE_TAG_NAME = 'h1';
